import React, { useEffect, useState } from 'react';
import noUiSlider, { Callback, Options, noUiSlider as NoUiSlider } from 'nouislider';

export interface NouisliderProps {
  value?: number;
  onChange?: Callback;
  onEnd?: Callback;
  onSet?: Callback;
  onSlide?: Callback;
  onStart?: Callback;
  onUpdate?: Callback;
  clickablePips?: boolean;
  paddings?: number | number[];
  instance?: (instance: NoUiSlider) => void;
}

interface NouisliderElement extends HTMLDivElement {
  noUiSlider?: noUiSlider.noUiSlider;
}

export const Nouislider = (props: NouisliderProps & Options) => {
  const {
    onUpdate,
    onChange,
    onSlide,
    onStart,
    onEnd,
    onSet,
    start,
    range,
    step,
    pips,
    value,
    instance
  } = props;
  const sliderContainer = React.useRef() as React.MutableRefObject<HTMLDivElement>;

  const [slider, setSlider] = useState<NouisliderElement['noUiSlider']>();
  const [isSyncing, setSyncing] = useState(true);

  useEffect(() => {
    const sliderInstance = noUiSlider.create(sliderContainer.current, {
      ...props,
      // @ts-ignore
      padding: props.paddings
    });

    if (onStart) {
      sliderInstance.on('start', onStart);
    }

    if (onSlide) {
      sliderInstance.on('slide', onSlide);
    }

    if (onUpdate) {
      sliderInstance.on('update', onUpdate);
    }

    if (onChange) {
      sliderInstance.on('change', onChange);
    }

    if (onSet) {
      sliderInstance.on('set', onSet);
    }

    if (onEnd) {
      sliderInstance.on('end', onEnd);
    }

    if (value) {
      sliderInstance.set(value);
    }

    sliderInstance.on('start', () => setSyncing(false));
    sliderInstance.on('end', () => setSyncing(true));

    setSlider(sliderInstance);

    instance?.(sliderInstance);

    return () => {
      sliderInstance.destroy();
    };
  }, [sliderContainer]);

  useEffect(() => {
    if (slider) {
      slider.updateOptions(props);

      if (!pips) {
        // @ts-ignore
        slider.removePips();
      }
    }
  }, [start, range.max, range.min, step, pips?.mode]);

  useEffect(() => {
    if (value !== undefined && isSyncing) {
      slider?.set(value);
    }
  }, [value]);

  if (props.clickablePips) {
    const sliderHTML = sliderContainer.current;
    const clickOnPip = (e: MouseEvent) => {
      e.stopPropagation();
      // @ts-ignore
      const value = Number(e.target?.getAttribute('data-value'));

      if (slider) {
        slider.set(value);
      }
    };

    if (sliderHTML) {
      sliderHTML.querySelectorAll<HTMLDivElement>('.noUi-value').forEach((pip: HTMLDivElement) => {
        pip.style.cursor = 'pointer';
        pip.addEventListener('click', clickOnPip);
      });
    }
  }

  return <div ref={sliderContainer} />;
};
